<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: "App",
        provide() {
            //   return {
            //     reload: this.reload
            //   }
        },
        data() {
            return {
                // isRouterAlive: true
            }
        },
        methods: {
            //  reload(){
            //    this.isRouterAlive = false
            //    this.$nextTick(function(){
            //      this.isRouterAlive = true
            //    })
            //  }
        }


    };
</script>

<style lang="less">

    #app {
        width: 100%;
        font-size: 14px;
        font-family: "Hiragino Sans GB", Microsoft YaHei, sans-serif;
    }

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        border: 0px;
        font-size: 14px;
    }

    textarea, input {
        background: none;
        outline: none;
        border: 0px;
    }

    a {
        cursor: pointer;
    }

    img {
        width: 100%;
        height: 100%;
        display: block;
        border: 0px;
    }

    button {
        border: none;
        background-color: transparent;
        outline: none;
        margin: 0px;
        padding: 0px;
    }

    .el-input--small .el-input__inner {
        height: 35px;
        line-height: 35px;
        font-size: 14px;
        width: 400px;
        border-radius: 20px;
    }

    .el-select .el-input__inner:focus {
        border-color: #409EFF;
    }

    .el-input--suffix .el-input__inner {
        width: 200px;
        border-radius: 20px;
    }

    .el-menu--horizontal > .el-menu-item {
        height: 40px;
        line-height: 40px;
        color: #343333;
    }

    input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
    }

    input::-webkit-input-placeholder {
        color: #C3C6CB;
    }

    input::-moz-input-placeholder {
        color: #C3C6CB;
    }

    input::-ms-input-placeholder {
        color: #C3C6CB;
    }

    .cursor {
        cursor: pointer;
    }

    button {
        cursor: pointer;
    }

    .page-box {
        padding: 20px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue